import lodash from "lodash";
import { useSelector } from "react-redux";
import { getConfig } from "../../modules/configuration";
import { Alert, AlertTitle, Typography } from "@mui/material";

export const Banners = () => {
  const config = useSelector(getConfig);

  return (
    !lodash.isEmpty(config.alert) && (
      <Alert severity={config.alert.type} variant="outlined">
        <AlertTitle>{config.alert.title}</AlertTitle>
        <Typography>{config.alert.description}</Typography>
      </Alert>
    )
  );
};
